import React from 'react'
import Image from 'next/image'
import Link from 'next/link'
import { useTranslations } from 'next-intl'
import { cx } from '@monorepo/helper/cx'

const Contact = ({
  person,
  profilePictureUrl,
  roundFormat,
}: {
  person: any
  profilePictureUrl?: string
  roundFormat?: boolean
}) => {
  const t = useTranslations('projects')

  return (
    <div className="mr-3 mt-3 flex">
      <Link href={`/contact-partners/${person.activeDirectoryId}`}>
        <div className={cx(roundFormat && 'flex gap-4', 'group h-full')}>
          <div className="w-25 relative aspect-square">
            {profilePictureUrl ? (
              <Image
                sizes="100px"
                alt={`${person.firstName} ${person.lastName}`}
                src={profilePictureUrl}
                fill
                style={{ objectFit: 'cover' }}
                className={cx(
                  'w-25',
                  roundFormat && 'h-25 rounded-full border-4 border-yellow-500',
                )}
              />
            ) : null}
            <div
              className="absolute hidden w-full justify-center group-hover:flex"
              style={{ bottom: 8 }}
            >
              <div
                className="bg-yellow-500 px-2 text-sm text-white"
                style={{
                  color: '#332e00',
                }}
              >
                {t('toProfile')}
              </div>
            </div>
          </div>
          <div
            className={cx(
              'text-sm',
              roundFormat && 'flex-col self-center font-medium',
            )}
          >
            <div
              className={cx(
                'break-words pt-2 font-medium leading-tight text-gray-700',
                roundFormat && '!text-base',
              )}
            >
              {person.firstName}
              {roundFormat ? ' ' : <br />}
              {person.lastName}
            </div>
            <div
              className={cx(
                'text-red-500',
                roundFormat && '!text-base text-gray-700',
              )}
            >
              {person.email}
            </div>
          </div>
        </div>
      </Link>
    </div>
  )
}

export default Contact
